export const Push = {
  Kind: {
    // 최대 20글자

    // 0번대 : 연결
    parentStudentLinked: 1, // 학부모-원의 학생 연결, 푸시는 학부모에게만 보냄
    studentStatusChanged: 2, // 외부생 -> 재원생 만 보냄
    studentStudentLinked: 3, // 학생사용자-원의 학생 연결, 푸시는 학부모에게만 보냄

    dummy: 10, // 체험용 푸시

    // 200번대 : 컨텐츠
    newBoardPost: 201,
    newNotePost: 202,
    newComment: 203,
    newPostReviewRequest: 204,

    // 300번대 : 학원비
    billSent: 301,
    billPaid: 302,
    wireTransferAck: 303, // 송금 확인

    // 400번대 : 상담톡
    newChatMessage: 401,

    // 500번대 : 출결
    attendance: 501,

    // 600번대 : 숙제/일정
    newHomework: 601,
    remindHomework: 602,

    // 700번대 : 리포트
    lessonRptPublished: 701,

    // 800번대 : 운영관련
    opsMsgChargeReport: 801,
    opsMsgQuotaAlert: 802,
    opsMsgOutOfQuota: 803,
    opsBillAutoIssueRpt: 804,
    opsContentPointAlert: 805,

    // 900번대 : custom
  },
  TaskState: {
    creating: -1,
    undone: 0,
    inProgress: 1,
    done: 2,
  },
  ItemState: {
    error: -1,
    notSent: 0,
    sent: 1,
    received: 2,
    checkedWhileRunning: 3,
    checkedWhileOff: 4,
  },
  OsType: {
    ios: 1,
    android: 2,
    web: 3,
  },
};
